import { useNavigate } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import { Button, Card, Description, Heading } from '@heroui/react';

const RESIDENT = [
  'Buscar vaga por período',
  'Emprestar ou alugar a própria vaga',
  'Aprovar solicitações dos vizinhos',
  'Ver a vaga na planta da garagem',
  'Subir no ranking do condomínio',
] as const;

const MANAGER = [
  'Cadastrar blocos, aptos e vagas',
  'Convidar e associar moradores',
  'Administrar mais de um condomínio',
  'Acompanhar usos e solicitações',
  'Receber relatos de mau uso',
] as const;

function BenefitList({ items }: { items: readonly string[] }) {
  return (
    <ul className="flex flex-col gap-2.5">
      {items.map((item) => (
        <li key={item} className="flex items-start gap-2 text-sm text-foreground">
          <Check size={16} className="mt-0.5 shrink-0 text-accent" />
          {item}
        </li>
      ))}
    </ul>
  );
}

export function LandingPersonas() {
  const navigate = useNavigate();

  return (
    <section id="sindicos" className="scroll-mt-24 border-t border-separator">
      <div className="mx-auto grid max-w-6xl gap-4 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:py-20">
        <Card>
          <Card.Content className="flex h-full flex-col gap-5 p-6 sm:p-8">
            <Description className="text-xs font-semibold uppercase tracking-wide text-accent">
              Para moradores
            </Description>
            <Heading level={2} className="text-2xl font-bold">
              Use a vaga. Ou deixe alguém usar.
            </Heading>
            <Description>
              Quem viaja libera. Quem recebe visita pede. Tudo com horário, tipo e histórico.
            </Description>
            <BenefitList items={RESIDENT} />
            <Button variant="outline" className="mt-auto w-fit" onPress={() => navigate('/login')}>
              Entrar como morador
              <ArrowRight size={16} />
            </Button>
          </Card.Content>
        </Card>

        <Card className="border-accent/30 bg-accent text-accent-foreground">
          <Card.Content className="flex h-full flex-col gap-5 p-6 sm:p-8">
            <p className="text-xs font-semibold uppercase tracking-wide text-accent-foreground/70">
              Para síndicos e gestoras
            </p>
            <Heading level={2} className="text-2xl font-bold text-accent-foreground">
              O condomínio no controle, sem virar despachante.
            </Heading>
            <p className="text-sm leading-relaxed text-accent-foreground/80">
              Estrutura física, membros e vagas em um painel. Os moradores resolvem entre si.
            </p>
            <ul className="flex flex-col gap-2.5">
              {MANAGER.map((item) => (
                <li key={item} className="flex items-start gap-2 text-sm">
                  <Check size={16} className="mt-0.5 shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
            <Button
              variant="secondary"
              className="mt-auto w-fit"
              onPress={() => navigate('/login')}
            >
              Falar com o time
              <ArrowRight size={16} />
            </Button>
          </Card.Content>
        </Card>
      </div>
    </section>
  );
}
